import { Grid } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/ErrorOutlineOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import ErrorIcon from '@material-ui/icons/ReportProblemOutlined';
import React from 'react';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { styles } from './dynamic-dialogue-styles';
import { useTranslation } from 'react-i18next';

type Props = IDynamicDialogue;

const DynamicDialogue: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  const displayIcon = () => {
    switch (props.iconType) {
      case EmeraldDialogTypes.Error:
        return <ErrorIcon classes={{ root: `${classes.iconError}` }}></ErrorIcon>;
      case EmeraldDialogTypes.Warning:
        return <WarningIcon classes={{ root: `${classes.iconWarning}` }}></WarningIcon>;
      default:
        return <InfoIcon classes={{ root: `${classes.iconInfo}` }}></InfoIcon>;
    }
  };

  return (
    <Grid container data-testid={`${props.dataTestIdPrefix || 'p'}-dynamic-dialogue`}>
      <Grid item xs={12}>
        <Grid data-testid={`${props.dataTestIdPrefix || 'p'}-dynamic-icon`}>{displayIcon()}</Grid>
        <Grid>
          <p
            className={classes.title}
            data-testid={`${props.dataTestIdPrefix || 'p'}-dynamic-title`}
          >
            {t(props.title ?? '')}
          </p>
          <p
            className={classes.message}
            data-testid={`${props.dataTestIdPrefix || 'p'}-dynamic-message`}
          >
            {t(props.message)}
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface IDynamicDialogue {
  iconType: EmeraldDialogTypes;
  title?: string;
  message: string;
  dataTestIdPrefix?: string;
}

export default DynamicDialogue;
